import React from 'react';
import { Label, Form } from 'semantic-ui-react';

class Field extends React.Component {

  render = () => {
    const {error, touched} = this.props
    return (
      <Form.Field width={this.props.width}>
        {this.props.children}
        {error && touched ?
        <Label basic color='red' pointing>{error}</Label> :
        null}
      </Form.Field>
    );
  }
}

export default Field;



// WEBPACK FOOTER //
// ./src/component/Field.js